import axios from "axios";
import config from "../config";

const AUTH_ENDPOINT_PATTERNS = [
  "/api/auth/login",
  "/api/auth/register",
  "/api/auth/forgot",
  "/api/auth/reset",
];

const parseUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user") || "null") || {};
  } catch {
    return {};
  }
};

const isBackendRequest = (url = "") => {
  if (!url) return true;

  const safeUrl = String(url);
  const isAbsolute = /^https?:\/\//i.test(safeUrl);
  if (!isAbsolute) return true;

  const apiBase = config.API_URL || "";
  const blApiBase = config.BL_API_URL || "";

  return (apiBase && safeUrl.startsWith(apiBase)) || (blApiBase && safeUrl.startsWith(blApiBase));
};

const isAuthEndpoint = (url = "") => {
  const safeUrl = String(url || "").toLowerCase();
  return AUTH_ENDPOINT_PATTERNS.some((pattern) => safeUrl.includes(pattern));
};

axios.interceptors.request.use(
  (request) => {
    if (!isBackendRequest(request?.url)) {
      return request;
    }

    // Avoid preflight/CORS issues on login and other unauthenticated auth calls.
    if (isAuthEndpoint(request?.url)) {
      return request;
    }

    // Allow per-request opt-out when backend CORS doesn't allow custom identity headers.
    if (request?.skipIdentityHeaders) {
      return request;
    }

    const accessToken =
      localStorage.getItem("accessToken") ||
      localStorage.getItem("accessKey") ||
      localStorage.getItem("accesstoken") ||
      localStorage.getItem("accesskey");

    // Do not send app/company identity headers until user is authenticated.
    if (!accessToken) {
      return request;
    }

    const user = parseUser();
    const appUserId =
      user?.appUserId ||
      user?.clientId ||
      user?.id ||
      localStorage.getItem("appUserId") ||
      localStorage.getItem("clientId");

    const companyId = user?.companyId || localStorage.getItem("companyId");

    request.headers = request.headers || {};

    if (appUserId !== null && appUserId !== undefined && appUserId !== "" && !request.headers.appUserId) {
      request.headers.appUserId = String(appUserId);
    }

    if (companyId !== null && companyId !== undefined && companyId !== "" && !request.headers.companyId) {
      request.headers.companyId = String(companyId);
    }

    return request;
  },
  (error) => Promise.reject(error)
);
